import * as WebFont from 'webfontloader';
import { of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import * as i3 from '@angular/forms';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, Pipe, Component, ViewEncapsulation, ViewChild, HostListener, EventEmitter, Injector, Directive, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from 'ngx-scrollbar';
import { NgScrollbarModule } from 'ngx-scrollbar';
import * as i5 from 'ngx-scrollbar/reached-event';
import { NgScrollReached } from 'ngx-scrollbar/reached-event';
const _c0 = ["dialogPopup"];
const _c1 = ["dialogScrollbar"];
const _c2 = (a0, a1) => ({
  active: a0,
  selected: a1
});
const _c3 = a0 => ({
  "font-family": a0
});
const _c4 = (a0, a1) => ({
  "active": a0,
  selected: a1
});
const _c5 = a0 => ({
  "size-select": a0
});
function FontPickerComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("arrow arrow-", ctx_r1.fpPosition, "");
    i0.ɵɵstyleProp("top", ctx_r1.arrowTop, "px");
  }
}
function FontPickerComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "input", 10);
    i0.ɵɵelementStart(2, "div", 11);
    i0.ɵɵlistener("click", function FontPickerComponent_div_3_Template_div_click_2_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSearchReset($event));
    });
    i0.ɵɵtext(3, "\xD7");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r1.fpSearchText || "");
    i0.ɵɵproperty("formControl", ctx_r1.searchTerm);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r1.searchTerm.value);
  }
}
function FontPickerComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.fpLoadingText || "");
  }
}
function FontPickerComponent_div_7_div_5_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21)(1, "span");
    i0.ɵɵtext(2, "!");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 22);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.fpPresetNotice || "This font is not from Google Fonts. If you select it, you might have to import it manually in your CSS rules.");
  }
}
function FontPickerComponent_div_7_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("click", function FontPickerComponent_div_7_div_5_Template_div_click_0_listener() {
      const fontItem_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onSelectFont(fontItem_r5));
    });
    i0.ɵɵelementStart(1, "div", 18)(2, "span", 19);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, FontPickerComponent_div_7_div_5_div_4_Template, 5, 1, "div", 20);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const fontItem_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c2, fontItem_r5.family.toLowerCase() === ctx_r1.font.family.toLowerCase(), ctx_r1.selectedFont))("ngStyle", i0.ɵɵpureFunction1(7, _c3, fontItem_r5.family));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(fontItem_r5.family || "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !fontItem_r5.files && ctx_r1.safeFonts.indexOf(fontItem_r5.family) === -1 && ctx_r1.googleFonts.length);
  }
}
function FontPickerComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 13)(2, "div", 14);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "div", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, FontPickerComponent_div_7_div_5_Template, 5, 9, "div", 16);
    i0.ɵɵpipe(6, "StatefulSlice");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.fpPresetLabel || "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(6, 3, ctx_r1.presetFonts, 0, ctx_r1.loadedFonts))("ngForTrackBy", ctx_r1.trackFont);
  }
}
function FontPickerComponent_ng_container_8_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 25);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.listLabel || "");
  }
}
function FontPickerComponent_ng_container_8_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("click", function FontPickerComponent_ng_container_8_div_2_Template_div_click_0_listener() {
      const fontItem_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onSelectFont(fontItem_r7));
    });
    i0.ɵɵelementStart(1, "div", 18)(2, "span", 19);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const fontItem_r7 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c4, fontItem_r7.family.toLowerCase() === ctx_r1.font.family.toLowerCase(), ctx_r1.selectedFont))("ngStyle", i0.ɵɵpureFunction1(6, _c3, fontItem_r7.family));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(fontItem_r7.family || "");
  }
}
function FontPickerComponent_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FontPickerComponent_ng_container_8_div_1_Template, 4, 1, "div", 23)(2, FontPickerComponent_ng_container_8_div_2_Template, 4, 8, "div", 24);
    i0.ɵɵpipe(3, "StatefulSlice");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.fpFilterByFamilies.length || ctx_r1.fpPresetFonts.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(3, 2, ctx_r1.currentFonts, 0, ctx_r1.loadedFonts));
  }
}
function FontPickerComponent_div_9_div_2_option_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 33);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "FontStyles");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const style_r9 = ctx.$implicit;
    i0.ɵɵproperty("value", style_r9);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, style_r9));
  }
}
function FontPickerComponent_div_9_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30)(1, "select", 31);
    i0.ɵɵlistener("change", function FontPickerComponent_div_9_div_2_Template_select_change_1_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onFontStyleChange($event, ctx_r1.font));
    });
    i0.ɵɵtwoWayListener("ngModelChange", function FontPickerComponent_div_9_div_2_Template_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.font.style, $event) || (ctx_r1.font.style = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵtemplate(2, FontPickerComponent_div_9_div_2_option_2_Template, 3, 4, "option", 32);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", !ctx_r1.font.styles);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.font.style);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.font.styles);
  }
}
function FontPickerComponent_div_9_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34)(1, "input", 35);
    i0.ɵɵpipe(2, "FontSize");
    i0.ɵɵlistener("change", function FontPickerComponent_div_9_div_3_Template_input_change_1_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onFontSizeChange($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c5, ctx_r1.fpStyleSelect))("ngModel", i0.ɵɵpipeBind1(2, 2, ctx_r1.font.size));
  }
}
function FontPickerComponent_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 27);
    i0.ɵɵtemplate(2, FontPickerComponent_div_9_div_2_Template, 3, 3, "div", 28)(3, FontPickerComponent_div_9_div_3_Template, 3, 6, "div", 29);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.fpStyleSelect);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.fpSizeSelect);
  }
}
function FontPickerComponent_div_10_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 38);
    i0.ɵɵlistener("click", function FontPickerComponent_div_10_button_1_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onUploadFont($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.fpUploadButtonClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.fpUploadButtonText || "Upload");
  }
}
function FontPickerComponent_div_10_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 38);
    i0.ɵɵlistener("click", function FontPickerComponent_div_10_button_2_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onCancelSelect($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.fpCancelButtonClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.fpCancelButtonText || "Cancel");
  }
}
function FontPickerComponent_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵtemplate(1, FontPickerComponent_div_10_button_1_Template, 2, 4, "button", 37)(2, FontPickerComponent_div_10_button_2_Template, 2, 4, "button", 37);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.fpUploadButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.fpCancelButton);
  }
}
const FONT_PICKER_CONFIG = new InjectionToken('FONT_PICKER_CONFIG');
class GoogleFontsInterface {
  kind;
  items;
}
class Font {
  size = '16px';
  style = 'regular';
  family = 'monospace';
  files = null;
  styles = ['regular'];
  constructor(props) {
    if (props) {
      this.size = props.size || '16px';
      this.style = props.style || 'regular';
      this.family = props.family || 'monospace';
      this.files = props.files || null;
      this.styles = props.styles || ['regular'];
    }
  }
  getStyles() {
    return {
      'font-size': this.size || '16px',
      'font-style': this.style.includes('italic') ? 'italic' : 'normal',
      'font-family': this.family || 'monospace',
      'font-weight': isNaN(Number(this.style.slice(0, 3))) ? 'normal' : this.style.slice(0, 3)
    };
  }
}
class FontPickerConfig {
  apiKey = '';
  constructor(config = {}) {
    this.assign(config);
  }
  assign(config = {}) {
    for (const key in config) {
      this[key] = config[key];
    }
  }
}
let FontPickerService = /*#__PURE__*/(() => {
  class FontPickerService {
    http;
    _config;
    apiKey = '';
    baseUrl = 'https://www.googleapis.com/webfonts/v1/webfonts';
    constructor(http, _config) {
      this.http = http;
      this._config = _config;
      this.apiKey = _config.apiKey || '';
    }
    /**
     * Loads the given font from Google Web Fonts.
     */
    loadFont(font) {
      try {
        WebFont.load({
          google: {
            families: [font.family + ':' + font.style]
          }
        });
      } catch (e) {
        console.warn('Failed to load the font:', font);
      }
    }
    /**
     * Returns list of all fonts with given sort option:
     * date || alpha || style || trending || popularity
     */
    getAllFonts(sort) {
      if (!this.apiKey) {
        return of(null);
      } else {
        let requestUrl = this.baseUrl + '?key=' + this.apiKey;
        if (sort) {
          requestUrl = requestUrl.concat('&sort=' + sort);
        }
        return this.http.get(requestUrl).pipe(catchError(this.handleHttpError));
      }
    }
    /**
     * Returns font object for the requested font family.
     */
    getRequestedFont(family) {
      const requestUrl = 'https://fonts.googleapis.com/css?family=' + family;
      return this.http.get(requestUrl).pipe(catchError(this.handleHttpError));
    }
    /**
     * Handler method for all possible http request errors.
     */
    handleHttpError(error) {
      console.error(error);
      const errMsg = error.error instanceof Error ? error.error.message : error.status || 'Unknown error';
      return of(errMsg);
    }
    static ɵfac = function FontPickerService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FontPickerService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(FONT_PICKER_CONFIG));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FontPickerService,
      factory: FontPickerService.ɵfac
    });
  }
  return FontPickerService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FontSizePipe = /*#__PURE__*/(() => {
  class FontSizePipe {
    transform(value) {
      return value ? parseInt(value.replace(/[^-\d\.]/g, '') || '16', 10) : 0;
    }
    static ɵfac = function FontSizePipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FontSizePipe)();
    };
    static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "FontSize",
      type: FontSizePipe,
      pure: true,
      standalone: false
    });
  }
  return FontSizePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FontStylesPipe = /*#__PURE__*/(() => {
  class FontStylesPipe {
    transform(value) {
      const lookup = {
        '100': 'Thin',
        '200': 'Extra-Light',
        '300': 'Light',
        '400': 'Regular',
        '500': 'Medium',
        '600': 'Semi-bold',
        '700': 'Bold',
        '800': 'Extra-bold',
        '900': 'Black'
      };
      for (const style in lookup) {
        const found = value && value.search(style);
        if (found >= 0 && value != null) {
          value = value.replace(style, lookup[style] + ' ');
          break;
        }
      }
      return value;
    }
    static ɵfac = function FontStylesPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FontStylesPipe)();
    };
    static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "FontStyles",
      type: FontStylesPipe,
      pure: true,
      standalone: false
    });
  }
  return FontStylesPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let StatefulSlicePipe = /*#__PURE__*/(() => {
  class StatefulSlicePipe {
    slicedArray = [];
    previousArrayRef = [];
    previousEndValue = 0;
    transform(arr, start, end) {
      if (arr && (this.previousEndValue !== end || this.previousArrayRef !== arr)) {
        this.slicedArray = arr.slice(start, end);
        this.previousArrayRef = arr;
        this.previousEndValue = end;
      }
      return this.slicedArray || arr;
    }
    static ɵfac = function StatefulSlicePipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StatefulSlicePipe)();
    };
    static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "StatefulSlice",
      type: StatefulSlicePipe,
      pure: false,
      standalone: false
    });
  }
  return StatefulSlicePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FontPickerComponent = /*#__PURE__*/(() => {
  class FontPickerComponent {
    cdRef;
    elRef;
    service;
    initialFont;
    testWidth;
    testContainer;
    autoWidth;
    listenerResize;
    listenerMouseDown;
    directiveInstance;
    directiveElementRef;
    useRootViewContainer = false;
    font;
    open;
    loading;
    top;
    left;
    position;
    arrowTop;
    listLabel;
    selectedFont;
    presetVisible;
    safeFonts = ['Arial', 'sans-serif', 'Times', 'serif', 'Courier', 'monospace'];
    fontAmount = 10;
    loadedFonts = 0;
    presetFonts = [];
    googleFonts = [];
    currentFonts = [];
    fpWidth;
    fpHeight;
    fpPosition;
    fpPositionOffset;
    fpSearchText;
    fpLoadingText;
    fpPopularLabel;
    fpResultsLabel;
    fpPresetLabel;
    fpPresetFonts;
    fpPresetNotice;
    fpSizeSelect;
    fpStyleSelect;
    fpCancelButton;
    fpCancelButtonText;
    fpCancelButtonClass;
    fpUploadButton;
    fpUploadButtonText;
    fpUploadButtonClass;
    fpDialogDisplay;
    fpFilterByFamilies = [];
    fpSortByFamilies = false;
    dialogArrowSize = 10;
    dialogArrowOffset = 15;
    searchTerm = new FormControl('');
    renderMore = new Subject();
    dialogElement;
    scrollbar;
    handleEsc(event) {
      if (this.open && this.fpDialogDisplay === 'popup') {
        this.onCancelSelect(event);
      }
    }
    handleEnter(event) {
      if (this.open && this.fpDialogDisplay === 'popup') {
        this.onAcceptSelect(event);
      }
    }
    constructor(cdRef, elRef, service) {
      this.cdRef = cdRef;
      this.elRef = elRef;
      this.service = service;
      this.loading = true;
      this.selectedFont = false;
      this.presetVisible = true;
    }
    ngOnInit() {
      this.renderMore.pipe(debounceTime(150)).subscribe(() => this.loadMoreFonts());
      this.searchTerm.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe(text => {
        if (!text) {
          this.presetVisible = true;
          this.listLabel = this.fpPopularLabel;
        } else {
          this.presetVisible = false;
          this.listLabel = this.fpResultsLabel;
        }
        this.searchGoogleFonts(text);
      });
      this.testContainer = document.createElement('span');
      this.testContainer.innerHTML = Array(100).join('wi');
      this.testContainer.style.cssText = ['position: absolute', 'left: -99999px', 'width: auto', 'font-size: 128px'].join(' !important;');
      this.listenerResize = () => this.onResize();
      this.listenerMouseDown = event => this.onMouseDown(event);
      this.openFontPicker();
    }
    trackFont(index, font) {
      return font.family || index.toString();
    }
    setDialog(instance, elementRef, fpUseRootViewContainer, defaultFont, fpWidth, fpHeight, fpDialogDisplay, fpSizeSelect, fpStyleSelect, fpPosition, fpPositionOffset, fpPositionRelativeToArrow, fpSearchText, fpLoadingText, fpPopularLabel, fpResultsLabel, fpPresetLabel, fpPresetFonts, fpPresetNotice, fpCancelButton, fpCancelButtonText, fpCancelButtonClass, fpUploadButton, fpUploadButtonText, fpUploadButtonClass, fpFilterByFamilies, fpSortByFamilies) {
      this.listLabel = fpLoadingText;
      this.directiveInstance = instance;
      this.directiveElementRef = elementRef;
      this.useRootViewContainer = fpUseRootViewContainer;
      this.updateDialog(defaultFont, fpWidth, fpHeight, fpDialogDisplay, fpSizeSelect, fpStyleSelect, fpPosition, fpPositionOffset, fpPositionRelativeToArrow, fpSearchText, fpLoadingText, fpPopularLabel, fpResultsLabel, fpPresetLabel, fpPresetFonts, fpPresetNotice, fpCancelButton, fpCancelButtonText, fpCancelButtonClass, fpUploadButton, fpUploadButtonText, fpUploadButtonClass, fpFilterByFamilies, fpSortByFamilies);
      this.service.getAllFonts('popularity').subscribe(fonts => {
        this.loading = false;
        if (fonts) {
          if (fonts.items) {
            this.googleFonts = fonts.items.map(font => {
              return new Font({
                files: font.files,
                family: font.family,
                styles: font.variants
              });
            });
          }
          if (fpFilterByFamilies?.length) {
            this.googleFonts = this.googleFonts.filter(font => fpFilterByFamilies.includes(font.family));
          }
          if (fpSortByFamilies) {
            this.googleFonts = this.googleFonts.sort((a, b) => a.family < b.family ? -1 : 1);
          }
          // Find styles for initial font
          const searchFont = this.findFont(this.initialFont.family, true);
          if (searchFont) {
            this.font.files = searchFont.files;
            this.font.styles = searchFont.styles;
            this.loadGoogleFonts([this.font]);
          }
          // Load Open Sans if available
          const openSans = this.googleFonts.find(font => font.family === 'Open sans');
          if (openSans) {
            this.loadGoogleFonts([openSans]);
          }
          this.setCurrentFonts(this.getPresetFonts().concat(this.googleFonts));
        } else {
          this.setCurrentFonts(this.getPresetFonts());
        }
      }, error => console.error(error));
    }
    updateDialog(font, fpWidth, fpHeight, fpDialogDisplay, fpSizeSelect, fpStyleSelect, fpPosition, fpPositionOffset, fpPositionRelativeToArrow, fpSearchText, fpLoadingText, fpPopularLabel, fpResultsLabel, fpPresetLabel, fpPresetFonts, fpPresetNotice, fpCancelButton, fpCancelButtonText, fpCancelButtonClass, fpUploadButton, fpUploadButtonText, fpUploadButtonClass, fpFilterByFamilies, fpSortByFamilies) {
      this.selectedFont = !!font;
      this.font = new Font(font);
      this.initialFont = new Font(font);
      this.fpPosition = fpPosition;
      this.fpPositionOffset = parseInt(fpPositionOffset, 10);
      if (!fpPositionRelativeToArrow) {
        this.dialogArrowOffset = 0;
      }
      if (fpDialogDisplay === 'inline') {
        this.dialogArrowSize = 0;
        this.dialogArrowOffset = 0;
      }
      this.fpSearchText = fpSearchText;
      this.fpLoadingText = fpLoadingText;
      this.fpPopularLabel = fpPopularLabel;
      this.fpResultsLabel = fpResultsLabel;
      this.fpSizeSelect = fpSizeSelect;
      this.fpStyleSelect = fpStyleSelect;
      this.fpPresetLabel = fpPresetLabel;
      this.fpPresetFonts = fpPresetFonts;
      this.fpPresetNotice = fpPresetNotice;
      this.fpCancelButton = fpCancelButton;
      this.fpCancelButtonText = fpCancelButtonText;
      this.fpCancelButtonClass = fpCancelButtonClass;
      this.fpUploadButton = fpUploadButton;
      this.fpUploadButtonText = fpUploadButtonText;
      this.fpUploadButtonClass = fpUploadButtonClass;
      this.fpFilterByFamilies = fpFilterByFamilies;
      this.fpSortByFamilies = fpSortByFamilies;
      this.autoWidth = fpWidth === 'auto';
      this.fpWidth = parseInt(fpWidth, 10);
      this.fpHeight = parseInt(fpHeight, 10);
      this.fpDialogDisplay = fpDialogDisplay;
      this.setCurrentFonts(this.getPresetFonts().concat(this.googleFonts));
      this.searchTerm.reset({
        value: '',
        disabled: this.fpPresetFonts.length > 0
      });
    }
    openFontPicker() {
      if (!this.open) {
        this.setDialogPosition();
        this.searchTerm.setValue('');
        window.addEventListener('resize', this.listenerResize);
        document.addEventListener('mousedown', this.listenerMouseDown);
        this.open = true;
      }
    }
    closeFontPicker() {
      this.open = false;
      window.removeEventListener('resize', this.listenerResize);
      document.removeEventListener('mousedown', this.listenerMouseDown);
    }
    isFontAvailable(font) {
      if (!this.testWidth) {
        this.testContainer.style.fontFamily = 'monospace';
        document.body.appendChild(this.testContainer);
        this.testWidth = this.testContainer.clientWidth;
        document.body.removeChild(this.testContainer);
      }
      this.testContainer.style.fontFamily = font.family + ', monospace';
      document.body.appendChild(this.testContainer);
      const width = this.testContainer.clientWidth;
      document.body.removeChild(this.testContainer);
      return width !== this.testWidth;
    }
    getPresetFonts() {
      const presetFonts = [];
      if (this.googleFonts && this.fpPresetFonts && this.fpPresetFonts.length) {
        this.fpPresetFonts.forEach(font => {
          let fontClass = this.findFont(font, true);
          if (!fontClass) {
            fontClass = new Font({
              family: font,
              styles: ['regular', 'italic']
            });
          }
          presetFonts.push(fontClass);
        });
        this.presetFonts = presetFonts;
      }
      return presetFonts;
    }
    setCurrentFonts(target) {
      if (target !== this.currentFonts) {
        this.currentFonts = target;
        this.loadedFonts = this.fontAmount;
        const initialFonts = this.currentFonts.slice(0, this.fontAmount);
        this.loadGoogleFonts(initialFonts);
        this.cdRef.markForCheck();
        setTimeout(() => {
          if (this.scrollbar) {
            this.scrollbar.scrollTo({
              top: 0
            });
          }
        }, 0);
      }
    }
    findFont(searchVal, exactMatch = false) {
      return this.findFonts(searchVal, exactMatch)[0];
    }
    findFonts(searchVal, exactMatch = false) {
      const fullmatchFonts = [];
      const candidateFonts = [];
      searchVal = searchVal.toLowerCase();
      this.googleFonts.forEach(font => {
        if (searchVal === font.family.toLowerCase()) {
          fullmatchFonts.push(font);
          return;
        }
        if (!exactMatch && font.family.toLowerCase().indexOf(searchVal) > -1) {
          candidateFonts.push(font);
        }
      });
      const resultFonts = fullmatchFonts.concat(candidateFonts);
      return resultFonts;
    }
    loadMoreFonts() {
      if (this.open && !this.loading && this.loadedFonts < this.currentFonts.length) {
        const moreFonts = this.currentFonts.slice(this.loadedFonts, this.loadedFonts + this.fontAmount);
        this.loadGoogleFonts(moreFonts);
        this.loadedFonts += moreFonts.length;
        this.cdRef.markForCheck();
        this.cdRef.detectChanges();
      }
    }
    loadGoogleFonts(fonts) {
      fonts.slice(0, this.fontAmount).forEach(font => {
        if (font && font.files && !this.isFontAvailable(font)) {
          const style = font.styles.indexOf('regular') > -1 ? '' : ':' + font.styles.find(x => !isNaN(x));
          this.service.loadFont({
            family: font.family,
            style: style,
            size: font.size
          });
        }
      });
    }
    searchGoogleFonts(value) {
      if (!value) {
        this.searchTerm.setValue('');
        this.setCurrentFonts(this.googleFonts);
      } else {
        value = value.toLowerCase();
        if (this.googleFonts) {
          this.loadedFonts = this.fontAmount;
          const searchResult = this.findFonts(value, false);
          this.setCurrentFonts(searchResult);
          this.cdRef.markForCheck();
        }
      }
    }
    isDescendant(parent, child) {
      let node = child.parentNode;
      while (node !== null) {
        if (node === parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    }
    createDialogBox(element, offset) {
      return {
        top: element.getBoundingClientRect().top + (offset ? window.pageYOffset : 0),
        left: element.getBoundingClientRect().left + (offset ? window.pageXOffset : 0),
        width: element.offsetWidth,
        height: element.offsetHeight
      };
    }
    setDialogPosition() {
      if (this.fpDialogDisplay === 'inline') {
        this.position = 'relative';
      } else {
        let position = 'static',
          transform = '',
          style;
        let parentNode = null,
          transformNode = null;
        let node = this.directiveElementRef.nativeElement.parentNode;
        const dialogHeight = this.dialogElement.nativeElement.offsetHeight;
        while (node !== null && node.tagName !== 'HTML') {
          style = window.getComputedStyle(node);
          position = style.getPropertyValue('position');
          transform = style.getPropertyValue('transform');
          if (position !== 'static' && parentNode === null) {
            parentNode = node;
          }
          if (transform && transform !== 'none' && transformNode === null) {
            transformNode = node;
          }
          if (position === 'fixed') {
            parentNode = transformNode;
            break;
          }
          node = node.parentNode;
        }
        const boxDirective = this.createDialogBox(this.directiveElementRef.nativeElement, position !== 'fixed');
        if (this.autoWidth) {
          this.fpWidth = this.directiveElementRef.nativeElement.offsetWidth;
        }
        if (this.useRootViewContainer || position === 'fixed' && (!parentNode || parentNode instanceof HTMLUnknownElement)) {
          this.top = boxDirective.top;
          this.left = boxDirective.left;
        } else {
          if (parentNode === null) {
            parentNode = node;
          }
          const boxParent = this.createDialogBox(parentNode, position !== 'fixed');
          this.top = boxDirective.top - boxParent.top;
          this.left = boxDirective.left - boxParent.left;
        }
        if (position === 'fixed') {
          this.position = 'fixed';
        }
        if (this.fpPosition === 'left') {
          this.top += boxDirective.height * this.fpPositionOffset / 100 - this.dialogArrowOffset;
          this.left -= this.fpWidth + this.dialogArrowSize - 2;
        } else if (this.fpPosition === 'top') {
          this.arrowTop = dialogHeight - 1;
          this.top -= dialogHeight + this.dialogArrowSize;
          this.left += this.fpPositionOffset / 100 * boxDirective.width - this.dialogArrowOffset;
        } else if (this.fpPosition === 'bottom') {
          this.top += boxDirective.height + this.dialogArrowSize;
          this.left += this.fpPositionOffset / 100 * boxDirective.width - this.dialogArrowOffset;
        } else {
          this.top += boxDirective.height * this.fpPositionOffset / 100 - this.dialogArrowOffset;
          this.left += boxDirective.width + this.dialogArrowSize - 2;
        }
      }
    }
    onResize() {
      if (this.position === 'fixed') {
        this.setDialogPosition();
      } else if (this.fpDialogDisplay !== 'inline') {
        this.closeFontPicker();
      }
    }
    onMouseDown(event) {
      if (this.fpDialogDisplay === 'popup' && event.target !== this.directiveElementRef.nativeElement && !this.isDescendant(this.elRef.nativeElement, event.target) && !this.isDescendant(this.directiveElementRef.nativeElement, event.target)) {
        this.closeFontPicker();
        this.cdRef.markForCheck();
      }
    }
    onUploadFont(event) {
      event.stopPropagation();
      this.directiveInstance.uploadFont();
    }
    onAcceptSelect(event) {
      event.stopPropagation();
      this.directiveInstance.fontChanged(this.font);
      if (this.fpDialogDisplay === 'popup') {
        this.closeFontPicker();
      }
    }
    onCancelSelect(event) {
      event.stopPropagation();
      this.selectedFont = false;
      this.font.size = this.initialFont.size;
      this.font.files = this.initialFont.files;
      this.font.style = this.initialFont.style;
      this.font.family = this.initialFont.family;
      this.font.styles = this.initialFont.styles;
      this.directiveInstance.fontChanged(this.font);
      if (this.fpDialogDisplay === 'popup') {
        this.closeFontPicker();
      }
    }
    onSelectFont(font) {
      this.selectedFont = true;
      this.font.files = font.files;
      this.font.family = font.family;
      this.font.styles = font.styles;
      this.font.style = font.styles.indexOf('regular') !== -1 ? 'regular' : font.styles[0];
      this.directiveInstance.fontChanged(this.font);
      this.cdRef.markForCheck();
      this.cdRef.detectChanges();
    }
    onSearchReset(event) {
      event.stopPropagation();
      this.searchTerm.setValue('');
      this.setCurrentFonts(this.googleFonts);
    }
    onFontSizeChange(event) {
      this.font.size = event.target.value + 'px';
      this.directiveInstance.fontChanged(this.font);
    }
    onFontStyleChange(event, font) {
      const str = this.font.family + ':' + event.target.value;
      if (font.files) {
        WebFont.load({
          google: {
            families: [str]
          }
        });
      }
      this.directiveInstance.fontChanged(this.font);
    }
    static ɵfac = function FontPickerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FontPickerComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(FontPickerService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FontPickerComponent,
      selectors: [["font-picker"]],
      viewQuery: function FontPickerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 7);
          i0.ɵɵviewQuery(_c1, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dialogElement = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scrollbar = _t.first);
        }
      },
      hostBindings: function FontPickerComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keyup.esc", function FontPickerComponent_keyup_esc_HostBindingHandler($event) {
            return ctx.handleEsc($event);
          }, false, i0.ɵɵresolveDocument)("keyup.enter", function FontPickerComponent_keyup_enter_HostBindingHandler($event) {
            return ctx.handleEnter($event);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      standalone: false,
      decls: 11,
      vars: 20,
      consts: [["dialogPopup", ""], ["dialogScrollbar", ""], [1, "font-picker"], [3, "class", "top", 4, "ngIf"], ["class", "search-box", 4, "ngIf"], ["class", "load-text", 4, "ngIf"], [1, "font-list", 3, "reachedBottom"], [4, "ngIf"], ["class", "button-area", 4, "ngIf"], [1, "search-box"], [1, "search-field", 3, "placeholder", "formControl"], [1, "search-reset", 3, "click", "hidden"], [1, "load-text"], [1, "font-group"], [1, "group-text"], [1, "group-line"], ["class", "font-item", 3, "ngClass", "ngStyle", "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "font-item", 3, "click", "ngClass", "ngStyle"], [1, "font-info"], [1, "font-name"], ["class", "not-available", 4, "ngIf"], [1, "not-available"], [1, "notice-text"], ["class", "font-group", 4, "ngIf"], ["class", "font-item", 3, "ngClass", "ngStyle", "click", 4, "ngFor", "ngForOf"], [1, "group-text", "black"], [1, "group-line", "black"], [1, "font-options"], ["class", "left", 4, "ngIf"], ["class", "right", 4, "ngIf"], [1, "left"], [1, "style-select", 3, "change", "ngModelChange", "disabled", "ngModel"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], [1, "right"], ["type", "number", "pattern", "[0-9]*", "min", "1", "max", "100", 3, "change", "ngClass", "ngModel"], [1, "button-area"], ["type", "button", 3, "class", "click", 4, "ngIf"], ["type", "button", 3, "click"]],
      template: function FontPickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 2, 0);
          i0.ɵɵtemplate(2, FontPickerComponent_div_2_Template, 1, 5, "div", 3)(3, FontPickerComponent_div_3_Template, 4, 3, "div", 4)(4, FontPickerComponent_div_4_Template, 2, 1, "div", 5);
          i0.ɵɵelementStart(5, "ng-scrollbar", 6, 1);
          i0.ɵɵlistener("reachedBottom", function FontPickerComponent_Template_ng_scrollbar_reachedBottom_5_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.renderMore.next($event));
          });
          i0.ɵɵtemplate(7, FontPickerComponent_div_7_Template, 7, 7, "div", 7)(8, FontPickerComponent_ng_container_8_Template, 4, 6, "ng-container", 7);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(9, FontPickerComponent_div_9_Template, 4, 2, "div", 7)(10, FontPickerComponent_div_10_Template, 3, 2, "div", 8);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵstyleProp("visibility", !ctx.open ? "hidden" : "visible")("height", ctx.fpHeight, "px")("width", ctx.fpWidth, "px")("top", ctx.top, "px")("left", ctx.left, "px")("position", ctx.position);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.fpDialogDisplay === "popup");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.googleFonts.length);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.loading);
          i0.ɵɵadvance();
          i0.ɵɵattribute("fxFlex", "auto");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.presetVisible && ctx.fpPresetFonts.length);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.googleFonts.length);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.selectedFont && (ctx.fpStyleSelect || ctx.fpSizeSelect));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.fpUploadButton || ctx.fpCancelButton);
        }
      },
      dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i2.NgStyle, i3.NgSelectOption, i3.ɵNgSelectMultipleOption, i3.DefaultValueAccessor, i3.NumberValueAccessor, i3.SelectControlValueAccessor, i3.NgControlStatus, i3.PatternValidator, i3.MinValidator, i3.MaxValidator, i3.NgModel, i3.FormControlDirective, i4.NgScrollbar, i5.NgScrollReached, FontSizePipe, FontStylesPipe, StatefulSlicePipe],
      styles: [".font-picker{position:absolute;z-index:1000;top:250px;left:30px;display:flex;flex-direction:column;width:280px;height:320px;min-width:200px;min-height:240px;border:#aaa solid 1px;cursor:default;-webkit-user-select:none;user-select:none;font-family:Open Sans,sans-serif;background-color:#fff}.font-picker[hidden]{display:none}.font-picker input,.font-picker select{width:100%;padding:4px;border:none;border-bottom:2px solid #cfcfcf;outline:none;font-size:14px;line-height:18px;text-align:left;background:none;transition:border .3s ease}.font-picker input:hover,.font-picker input:focus,.font-picker input:active,.font-picker select:hover,.font-picker select:focus,.font-picker select:active{border-bottom:2px solid #999}.font-picker input:invalid,.font-picker select:invalid{border-bottom:2px solid #e74c3c;box-shadow:none}.font-picker input::-webkit-inner-spin-button,.font-picker input::-webkit-outer-spin-button{margin:0;-webkit-appearance:none}.font-picker .arrow{position:absolute;z-index:999999;width:0;height:0;border-style:solid}.font-picker .arrow.arrow-left{top:10px;left:231px;border-width:5px 10px;border-color:rgba(0,0,0,0) rgba(0,0,0,0) rgba(0,0,0,0) #777}.font-picker .arrow.arrow-right{top:10px;left:-20px;border-width:5px 10px;border-color:rgba(0,0,0,0) #777 rgba(0,0,0,0) rgba(0,0,0,0)}.font-picker .arrow.arrow-top{top:0;left:10px;border-width:10px 5px;border-color:#777 rgba(0,0,0,0) rgba(0,0,0,0) rgba(0,0,0,0)}.font-picker .arrow.arrow-bottom{top:-20px;left:10px;border-width:10px 5px;border-color:rgba(0,0,0,0) rgba(0,0,0,0) #777 rgba(0,0,0,0)}.font-picker .search-box{position:relative}.font-picker .search-field{box-sizing:border-box;padding:10px 48px 10px 16px}.font-picker .search-field:disabled{opacity:.8;cursor:not-allowed;background-color:#eee}.font-picker .search-reset{position:absolute;top:0;right:0;padding:0 12px;cursor:pointer;font-size:30px;line-height:36px;color:#777;transition:color .3s ease}.font-picker .search-reset:hover{color:#555}.font-picker .load-text{padding:16px;font-size:12px;text-align:center;color:#000}.font-picker .font-list{position:relative;overflow:hidden;flex:1 1 auto}.font-picker .font-list .font-item{position:relative;padding:8px 16px;cursor:pointer}.font-picker .font-list .font-item.active{font-weight:700}.font-picker .font-list .font-item.active.selected{cursor:default;font-weight:400;background:#d9d9d9}.font-picker .font-list .font-item .font-info{margin:4px 0}.font-picker .font-list .font-item .font-info .font-name{font-size:14px;text-transform:capitalize;color:#555}.font-picker .font-list .font-item .font-info .not-available{float:right;width:24px;margin:-8px -8px 0 0;font-size:24px;font-weight:900;font-family:Open Sans,sans-serif;text-align:center;text-transform:none;color:#ef8b80}.font-picker .font-list .font-item .font-info .not-available .notice-text{content:\"This font is not from Google Fonts. If you select it, you might have to import it manually in your CSS rules.\";position:absolute;z-index:10;top:0;right:12px;left:12px;opacity:0;padding:12px 16px;margin:0 auto;border-radius:2px;pointer-events:none;font-size:13px;font-weight:400;text-align:left;color:#fff;background:#3c3c3ccc;transition:opacity .15s ease}.font-picker .font-list .font-item .font-info .not-available:hover{color:#ea6153}.font-picker .font-list .font-item .font-info .not-available:hover .notice-text{opacity:1}.font-picker .font-list .font-item .font-text{padding:4px 0;font-size:16px;text-align:right;color:#999}.font-picker .font-list .font-group{display:flex;flex:none}.font-picker .font-list .font-group .group-line{flex:1 1 auto;height:2px;margin-top:14px;margin-right:12px;background:#e74c3c}.font-picker .font-list .font-group .group-line.black{background:#000}.font-picker .font-list .font-group .group-text{overflow:hidden;box-sizing:border-box;max-width:75%;padding:8px 12px;font-size:11px;font-weight:700;white-space:nowrap;text-align:left;text-overflow:ellipsis;color:#e74c3c}.font-picker .font-list .font-group .group-text.black{color:#000}.font-picker .font-options{display:flex;box-sizing:border-box;padding:8px;border-top:2px solid #cfcfcf}.font-picker .font-options .left{flex:1 1 auto;padding:0 2px}.font-picker .font-options .left .style-select{text-transform:capitalize}.font-picker .font-options .left .style-select:disabled{background-color:#777}.font-picker .font-options .right{padding:3px 2px}.font-picker .font-options .right .size-select{width:48px;text-align:center}.font-picker .button-area{padding:0 4px 4px;border-top:1px solid #aaa;text-align:right}.font-picker .button-area .fp-cancel-button-class,.font-picker .button-area .fp-upload-button-class{display:inline-block;margin:8px;text-align:center;text-transform:uppercase}\n"],
      encapsulation: 2
    });
  }
  return FontPickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FontPickerDirective = /*#__PURE__*/(() => {
  class FontPickerDirective {
    injector;
    resolver;
    appRef;
    vcRef;
    elRef;
    cdRef;
    service;
    dialog;
    fontPicker;
    fpWidth = '280px';
    fpHeight = '320px';
    fpFallbackFont = {
      family: 'Roboto',
      size: '16px',
      style: 'regular',
      styles: ['regular']
    };
    fpAutoLoad = true;
    fpPresetLabel = '';
    fpPresetFonts = [];
    fpPresetNotice = '';
    fpSizeSelect = true;
    fpStyleSelect = true;
    fpDialogDisplay = 'popup';
    fpUseRootViewContainer = false;
    fpPosition = 'bottom';
    fpPositionOffset = '0%';
    fpPositionRelativeToArrow = false;
    fpSearchText = 'Search fonts...';
    fpLoadingText = 'Loading fonts...';
    fpPopularLabel = 'Popular fonts';
    fpResultsLabel = 'Search results';
    fpCancelButton = false;
    fpCancelButtonText = 'Cancel';
    fpCancelButtonClass = 'fp-cancel-button-class';
    fpUploadButton = false;
    fpUploadButtonText = 'Upload';
    fpUploadButtonClass = 'fp-upload-button-class';
    fpFilterByFamilies = [];
    fpSortByFamilies = false;
    fontPickerUpload = new EventEmitter();
    fontPickerChange = new EventEmitter();
    onClick() {
      this.toggleDialog();
    }
    constructor(injector, resolver, appRef, vcRef, elRef, cdRef, service) {
      this.injector = injector;
      this.resolver = resolver;
      this.appRef = appRef;
      this.vcRef = vcRef;
      this.elRef = elRef;
      this.cdRef = cdRef;
      this.service = service;
    }
    ngOnInit() {
      this.fontPicker = this.fontPicker || this.fpFallbackFont;
    }
    ngOnChanges(changes) {
      if (changes.fontPicker) {
        this.fontPicker = this.fontPicker || this.fpFallbackFont;
        if (this.fpAutoLoad) {
          this.loadFont(this.fontPicker);
        }
      }
      if (changes.fpSortByFamilies || changes.fpFilterByFamilies) {
        this.dialog = undefined;
      }
    }
    loadFont(font) {
      this.service.loadFont(font);
    }
    uploadFont() {
      this.fontPickerUpload.emit();
    }
    openDialog() {
      if (!this.dialog || !this.dialog.open) {
        this.toggleDialog();
      }
    }
    closeDialog() {
      if (this.dialog && this.dialog.open) {
        this.toggleDialog();
      }
    }
    toggleDialog() {
      if (!this.dialog) {
        let vcRef = this.vcRef;
        if (this.fpUseRootViewContainer && this.fpDialogDisplay !== 'inline') {
          const classOfRootComponent = this.appRef.componentTypes[0];
          const appInstance = this.injector.get(classOfRootComponent);
          vcRef = appInstance.vcRef || appInstance.viewContainerRef || this.vcRef;
          if (vcRef === this.vcRef) {
            console.warn('You are using fpUseRootViewContainer, ' + 'but the root component is not exposing viewContainerRef!' + 'Please expose it by adding \'public vcRef: ViewContainerRef\' to the constructor.');
          }
        }
        const compFactory = this.resolver.resolveComponentFactory(FontPickerComponent);
        const injector = Injector.create({
          providers: [],
          parent: vcRef.parentInjector
        });
        this.dialog = vcRef.createComponent(compFactory, 0, injector, []).instance;
        this.dialog.setDialog(this, this.elRef, this.fpUseRootViewContainer, this.fontPicker, this.fpWidth, this.fpHeight, this.fpDialogDisplay, this.fpSizeSelect, this.fpStyleSelect, this.fpPosition, this.fpPositionOffset, this.fpPositionRelativeToArrow, this.fpSearchText, this.fpLoadingText, this.fpPopularLabel, this.fpResultsLabel, this.fpPresetLabel, this.fpPresetFonts, this.fpPresetNotice, this.fpCancelButton, this.fpCancelButtonText, this.fpCancelButtonClass, this.fpUploadButton, this.fpUploadButtonText, this.fpUploadButtonClass, this.fpFilterByFamilies, this.fpSortByFamilies);
      } else if (!this.dialog.open) {
        this.dialog.updateDialog(this.fontPicker, this.fpWidth, this.fpHeight, this.fpDialogDisplay, this.fpSizeSelect, this.fpStyleSelect, this.fpPosition, this.fpPositionOffset, this.fpPositionRelativeToArrow, this.fpSearchText, this.fpLoadingText, this.fpPopularLabel, this.fpResultsLabel, this.fpPresetLabel, this.fpPresetFonts, this.fpPresetNotice, this.fpCancelButton, this.fpCancelButtonText, this.fpCancelButtonClass, this.fpUploadButton, this.fpUploadButtonText, this.fpUploadButtonClass, this.fpFilterByFamilies, this.fpSortByFamilies);
        this.dialog.openFontPicker();
      } else {
        this.dialog.closeFontPicker();
      }
    }
    fontChanged(font) {
      this.fontPickerChange.emit(font);
      this.cdRef.markForCheck();
      this.cdRef.detectChanges();
    }
    static ɵfac = function FontPickerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FontPickerDirective)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver), i0.ɵɵdirectiveInject(i0.ApplicationRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(FontPickerService));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FontPickerDirective,
      selectors: [["", "fontPicker", ""]],
      hostBindings: function FontPickerDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function FontPickerDirective_click_HostBindingHandler() {
            return ctx.onClick();
          });
        }
      },
      inputs: {
        fontPicker: "fontPicker",
        fpWidth: "fpWidth",
        fpHeight: "fpHeight",
        fpFallbackFont: "fpFallbackFont",
        fpAutoLoad: "fpAutoLoad",
        fpPresetLabel: "fpPresetLabel",
        fpPresetFonts: "fpPresetFonts",
        fpPresetNotice: "fpPresetNotice",
        fpSizeSelect: "fpSizeSelect",
        fpStyleSelect: "fpStyleSelect",
        fpDialogDisplay: "fpDialogDisplay",
        fpUseRootViewContainer: "fpUseRootViewContainer",
        fpPosition: "fpPosition",
        fpPositionOffset: "fpPositionOffset",
        fpPositionRelativeToArrow: "fpPositionRelativeToArrow",
        fpSearchText: "fpSearchText",
        fpLoadingText: "fpLoadingText",
        fpPopularLabel: "fpPopularLabel",
        fpResultsLabel: "fpResultsLabel",
        fpCancelButton: "fpCancelButton",
        fpCancelButtonText: "fpCancelButtonText",
        fpCancelButtonClass: "fpCancelButtonClass",
        fpUploadButton: "fpUploadButton",
        fpUploadButtonText: "fpUploadButtonText",
        fpUploadButtonClass: "fpUploadButtonClass",
        fpFilterByFamilies: "fpFilterByFamilies",
        fpSortByFamilies: "fpSortByFamilies"
      },
      outputs: {
        fontPickerUpload: "fontPickerUpload",
        fontPickerChange: "fontPickerChange"
      },
      exportAs: ["ngxFontPicker"],
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
  return FontPickerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FontPickerModule = /*#__PURE__*/(() => {
  class FontPickerModule {
    static ɵfac = function FontPickerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FontPickerModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: FontPickerModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [FontPickerService],
      imports: [CommonModule, HttpClientModule, FormsModule, ReactiveFormsModule, NgScrollbarModule, FormsModule, ReactiveFormsModule]
    });
  }
  return FontPickerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { FONT_PICKER_CONFIG, Font, FontPickerComponent, FontPickerConfig, FontPickerDirective, FontPickerModule, FontPickerService, FontSizePipe, FontStylesPipe, GoogleFontsInterface, StatefulSlicePipe };
